import Drawer from 'devextreme-react/drawer';
import SideMenu from './side-menu/side-menu';
import { useCarrierPortalGlobalStore } from '../../../stores/carrier-portal-global-store';
import '../../../common/themes/styles/dx.generic.dark-theme.css';
import '../../../common/themes/styles/dx.generic.blue-theme.css';
import '../../../common/themes/styles/dx.generic.green-theme.css';
import './side-nav.scss';

const SideNav = () => {
  const [isSideNavOpened] = useCarrierPortalGlobalStore<boolean>(
    store => store.menu.isSideNavOpened
  );

  const [selectedTheme] = useCarrierPortalGlobalStore(
    store => store.store.selectedTheme
  );

  const themesObj: any = {
    blue: 'dx-swatch-blue-theme',
    dark: 'dx-swatch-dark-theme',
    light: '',
    green: 'dx-swatch-green-theme'
  };

  return (
    <div className={themesObj[selectedTheme]}>
      <div className="drawer-div main-side-menu">
        <Drawer
          className={`${isSideNavOpened ? '' : 'side-menu-collapse'}`}
          opened={!!isSideNavOpened}
          openedStateMode="shrink"
          position="left"
          revealMode="slide"
          closeOnOutsideClick={false}
          render={() => <SideMenu />}
        >
          <div></div>
        </Drawer>
      </div>
    </div>
  );
};

export default SideNav;
